class Tools {
    static getQuotes(input, formatfunc) {
        var quotes = [];
        input.matchEach(/(\\*)([\'\"])/g, function($0, $1, $2, pos) {
            pos = pos + $1.length;
            if ($1.length % 2 == 0) quotes.push({type:$2, pos:pos})
            return $0
        })
    
        var quotespos = [];
        var current = {type:null, spos:null, epos:null};
        for (var i = 0; i < quotes.length; i++) {
            var item = quotes[i];
            if (!current.type) {
                current.type = item.type;
                current.spos = item.pos;
            } else {
                if (current.type == item.type) {
                    current.epos = item.pos;
                    quotespos.push(current);
                    current = {type:null, spos:null, epos:null};
                }
            }
        }
    
        var strmap = [];
        var output = "";
        var curpos = 0;
        if (!quotespos.length) {
            return {strmap:null, output:input};
        }
        for (var i = 0; i < quotespos.length; i++) {
            var quotestr = input.substring(quotespos[i].spos + 1, quotespos[i].epos);
            strmap.push(quotestr);
            output += (curpos == quotespos[i].spos ? "" : input.substring(curpos, quotespos[i].spos)) + (formatfunc ? formatfunc(quotestr, i) : '{' + i + '}');
            curpos = quotespos[i].epos + 1
        }
        output += input.substring(quotespos[quotespos.length - 1].epos + 1);
        return {strmap:strmap, output:output};
    }
}

export default Tools;